// file: cartBundleTile.jsx
import React, { useEffect } from "react";
import styles from "./CartBundleTile.module.scss";
import {
  getAllProduct,
  getCustomerById,
  getPendingOrdersResponse,
  getProductById,
} from "../../../store/actions";
import { connect, useDispatch } from "react-redux";
import { getObjectFromArrayOfObjects } from "../../../utils/common/CommonFunctions";
import { useNavigate } from "react-router-dom";
import OutlinedButton from "../../customComponents/outlinedButton/OutlinedButton";

const CartBundleTile = ({ cartBundleData, products = [] }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getAllProduct());
  }, []);
  const items = [
    {
      id: 1,
      image: "milk1.png", // replace with actual image url
      name: "Milk Product",
      orderId: "45679",
      qty: 2,
      size: "500ml",
      price: "₹100",
    },
    {
      id: 2,
      image: "milk2.png",
      name: "Milk Product",
      orderId: "45679",
      qty: 2,
      size: "500ml",
      price: "₹100",
    },
    {
      id: 3,
      image: "milk3.png",
      name: "Milk Product",
      orderId: "45679",
      qty: 2,
      size: "500ml",
      price: "₹100",
    },
  ];

  console.log("cartBundleData", cartBundleData);
  const getProductDetails = (item) => {
    const getProduct = getObjectFromArrayOfObjects(
      products,
      "id",
      item?.productId
    );
    return getProduct;
  };

  const handleNavigate = (item = {}) => {
    console.log(item);
    dispatch(getPendingOrdersResponse(item));
    dispatch(getProductById({ id: item?.productId }));
    dispatch(getCustomerById({ id: item?.customerId }));
    setTimeout(() => {
      navigate("/orderdetails");
    }, 100);
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Products Ordered</h3>
      <div className={styles.wrapper}>
        {cartBundleData?.orders?.map((item) => (
          <div key={item.id} className={styles.card}>
            <div className={styles.left}>
              <img
                src={getProductDetails(item)?.imageUrl}
                alt={item.name}
                className={styles.productImage}
              />
            </div>
            <div className={styles.middle}>
              <h4 className={styles.productName}>
                {getProductDetails(item)?.name}
              </h4>
              <div className={styles.orderId}>
                <OutlinedButton
                  title={`Order ID :${item?.orderCode}`}
                  txtClr={"hsla(187, 98%, 16%, 1)"}
                  border={"1px solid hsla(187, 98%, 16%, 1)"}
                  width={"90px"}
                  height={"34px"}
                  borderRadius={"12px"}
                  onclick={() => handleNavigate(item)}
                />
              </div>
            </div>
            <div className={styles.right}>
              <span className={styles.price}>₹ {item?.total}</span>
              <p className={styles.productMeta}>
                Qty : {item?.quantity} | Size :{" "}
                {getProductDetails(item)?.weight}{" "}
                {getProductDetails(item)?.siUnit}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    products: state?.product?.products,
  };
};

export default connect(mapStateToProps, null)(CartBundleTile);
